// extracted by mini-css-extract-plugin
export default {"wrapper":"_3KrWb","dot":"_3tn4X","tooltip-content":"_2cRtp","tooltipContent":"_2cRtp"};